import { SubDepartmentModel } from "./SubDepartmentModel";


export class DepartmentModel {
    Department_Code: string ="";
    Department_Name: string="";
    SubDepartments : SubDepartmentModel[] = [];
    Active: boolean = false;
    Created_By : number = 0;
}